export default "__VITE_ASSET__B1EIw9S2__"